import { Component, OnInit } from '@angular/core';
import { NavService } from '../../../../services/nav.service';
import { LocalizationDataService } from 'src/app/services/data/localization-data.service';

@Component({
  selector: 'app-languages',
  templateUrl: './languages.component.html',
  styleUrls: ['./languages.component.scss']
})
export class LanguagesComponent implements OnInit {

  public language: boolean = false;

  public languages: any[] = [{
    language: 'English',
    code: 'en',
    type: 'US',
    icon: 'us'
  },
  {
    language: 'Français',
    code: 'fr',
    icon: 'fr'
  },
  {
    language: 'Arabic',
    code: 'ar',
    icon: 'sa'
  },
]

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: 'us'
  }

  constructor(public navServices: NavService, public localizationDataService: LocalizationDataService) { }
  // 
  ngOnInit() {
    const saved = localStorage.getItem('app_lang');
    const fallback = this.selectedLanguage;
    const lang = saved ? this.languages.find(l => l.code === saved) || fallback : fallback;

    this.localizationDataService.currentLanguage$.subscribe(currentLang => {
      console.log(currentLang);
      const chosen = currentLang || lang;
      this.selectedLanguage = chosen;
      // Ensure dir/lang are applied on first load
      const isRTL = chosen.code === 'ar';
      const html = document.documentElement;
      html.setAttribute('lang', chosen.code);
      html.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
      html.classList.toggle('rtl', isRTL);
    });

    if (!saved) this.changeLanguage(lang);
  }


  changeLanguage(lang: any) {
    this.selectedLanguage = lang;
    this.localizationDataService.setLocale(lang);

    const isRTL = lang.code === 'ar';
    const html = document.documentElement;

    html.setAttribute('lang', lang.code);
    html.setAttribute('dir', isRTL ? 'rtl' : 'ltr');

    // Optional: add/remove a helper class for CSS overrides
    html.classList.toggle('rtl', isRTL);

    // Persist choice
    localStorage.setItem('app_lang', lang.code);
  }
}
